/**
 * De-duplicate GetSearchData rows before Slot Search groups them.
 *
 * - Insight machines rows (`source: 'insight'` with an mnum): one row per
 *   machine id. floorLocation (aliased onto slot_number) is a placement code
 *   that two machines can share, so it must not be the dedupe key here.
 * - Legacy / Timescale rows (no mnum): unchanged — first row per slot_number
 *   (or slotNumber) wins; rows without either are always kept.
 */
type SearchRowLike = {
  source?: unknown;
  mnum?: unknown;
  slot_number?: unknown;
  slotNumber?: unknown;
};

const present = (v: unknown): boolean => v !== undefined && v !== null && String(v).trim() !== '';

export function dedupeSearchRows<T>(rows: T[] | null | undefined): T[] {
  if (!Array.isArray(rows)) return [];
  const seen = new Set<string>();
  return rows.filter((row) => {
    const item = (row ?? {}) as SearchRowLike;
    if (item.source === 'insight' && present(item.mnum)) {
      const key = `mnum:${String(item.mnum).trim()}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    }
    const sn = item.slot_number ?? item.slotNumber;
    if (sn === undefined || sn === null || sn === '') return true;
    const key = String(sn).trim();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
